import { render, staticRenderFns } from "./SettingsPassword.vue?vue&type=template&id=420c61b0&"
import script from "./SettingsPassword.vue?vue&type=script&lang=js&"
export * from "./SettingsPassword.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPassword.vue?vue&type=style&index=0&id=420c61b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports